import React from 'react';
import { Row, Col } from 'react-bootstrap';

import NewLegend from './chartLegend';
import Histogram from './histogram';

interface AnimatedHistogramChartCardProps {
	chartId: string;
	order: string[];
	data: Record<
		string,
		{
			label: string;
			value: number;
			color: string;
			tooltip: string;
		}
	>;
	title: string;
	cardData: any;
	totalName?: string;
	labelOnHover?: boolean;
}

const AnimatedHistogramChartCard = ({
	chartId,
	data,
	order,
	cardData,
	title,
	labelOnHover = true,
	totalName = 'totalAmount',
}: AnimatedHistogramChartCardProps) => {
	const dataPoints = Object.entries(data)
		.filter(([key]) => order.includes(key))
		.sort(([aKey], [bKey]) => order.indexOf(aKey) - order.indexOf(bKey))
		.map(([key, value]) => {
			return {
				field: key,
				label: value.label,
				mainValue: value.value,
				color: value.color,
				tooltip: value.tooltip,
			};
		});

	return (
		<>
			<Row className="flex-column align-items-center justify-content-between" style={{ minHeight: '30rem' }}>
				<h5 className="title-box mb-3">{title}</h5>

				<Col className="col-auto">
					<Row className="flex-column justify-content-center align-items-center w-100 m-auto">
						<Col className="col-12 d-flex justify-content-center align-items-center">
							<Histogram data={dataPoints} />
						</Col>
					</Row>
				</Col>

				<Col>
					<Row className="flex-column justify-content-center align-items-center w-100 m-auto mt-3">
						{cardData.length > 0 && <NewLegend data={cardData} scope={title} totalName={totalName} className={chartId} totalValue />}
					</Row>
				</Col>
			</Row>
		</>
	);
};

export default AnimatedHistogramChartCard;
